import { Payment } from '@/models/api/payment/payment'
import PaymentService, { ListAllowedPaymentsFor } from '@/services/api/payment'
import { Either } from 'fp-ts/lib/Either'

/**
 * 定期購入の文脈でのみ利用する、支払い方法一覧取得api client.
 *
 * 定期購入では利用できる支払い方法が制限されているが、
 * その制約は「定期購入」という購入方法に由来するものではなく、
 * 外部ベンダーが提供するツールの制約に由来するものである.
 *
 * 外部ベンダーツールの制約に由来するものであれば、中核の知識として中央に埋め込むというよりは、
 * いつひっくり返るかわからない偶有的な制約として、いつでも着脱可能にしておきたい意図.
 *
 * 上記のような理由から、「定期購入の場合に使える支払い方法は〜」を知識の中核として
 * サーバー側のモデル実装に埋め込むのではなく、クエリパラメータで抽出するという実装を取り、
 * 「〜な購入方法の場合、支払い方法は〜」という知識は周辺的で偶有的なものとして扱う形を取った.
 *
 * @deprecated 外部ベンダーツールの都合による偶発的制約に対処するためのものであり、将来的にはこのモジュールは削除されることが望ましい.
 * @see https://www.chatwork.com/#!rid87550748-1487317407046324224
 * @see https://github.com/my-color/front/issues/5624
 */
export class PaymentServiceForSubscription {
  constructor(private readonly client: PaymentService) {
  }

  public async get(
    cartIdList: string[],
    query: Omit<ListAllowedPaymentsFor, 'context'>
  ): Promise<Either<Error, Payment[]>> {
    return this.client.listAllowedPaymentsFor(cartIdList, {
      context: 'subscription',
      ...query,
    })
  }
}
